import type { Partenaire } from '~/api/gen'

// Données mock pour GET /partenaires/{officeOid}.
// `partenaire` correspond aux ids du PARTNERS_CATALOG, `code` aux code_produit
// des diffusions mock. Le pack souscrit (quota / type de diffusion) vient de la
// table produit_organisation du datalake : Immonot est en illimité (pas de
// quota), Leboncoin et SeLoger ont un quota — le carrousel s'appuie dessus.
export const partenaires: Partenaire[] = [
  {
    partenaire: 'immonot',
    label: 'Immonot',
    code: 'LEI',
    nombreAnnonces: 12,
    typeDiffusion: 'UNLIMITED',
  },
  {
    partenaire: 'leboncoin',
    label: 'Leboncoin',
    code: 'LBC',
    nombreAnnonces: 8,
    quotaAnnonces: 50,
    typeDiffusion: 'LIMITED',
  },
  {
    partenaire: 'se-loger',
    label: 'SeLoger',
    code: 'SLG',
    nombreAnnonces: 5,
    quotaAnnonces: 10,
    typeDiffusion: 'LIMITED',
  },
]
